//LAZY LOAD !!
document.addEventListener("DOMContentLoaded", function() {
    let lazyloadImages = document.querySelectorAll("img.lazy");
    let lazyloadSources = document.querySelectorAll("source.lazy");
    let lazyloadThrottleTimeout;

    function lazyload () {

        if(lazyloadThrottleTimeout) {
            clearTimeout(lazyloadThrottleTimeout);
        }

        lazyloadThrottleTimeout = setTimeout(function() {

            lazyloadImages = document.querySelectorAll("img.lazy");
            lazyloadSources = document.querySelectorAll("source.lazy");

            let scrollTop = window.pageYOffset;
            if(lazyloadImages.length > 0){
              lazyloadImages.forEach(function(img, index) {
                  if(img.offsetTop < (window.innerHeight + scrollTop)) {
                      img.src = img.dataset.src;
                      img.classList.remove('lazy');
                  }
              });
            }
            if(lazyloadSources.length > 0){
              lazyloadSources.forEach(function(img, index) {
                  if(img.offsetTop < (window.innerHeight + scrollTop)) {
                      img.srcset = img.dataset.srcset;
                      img.classList.remove('lazy');
                  }
              });
            }
            if(lazyloadSources.length == 0 && lazyloadImages.length == 0) {
                window.removeEventListener("scroll", lazyload);
                window.removeEventListener("resize", lazyload);
                window.removeEventListener("orientationChange", lazyload);
            }
        }, 20);

        let imgDefer = document.querySelectorAll('div[data-srcbg], a[data-srcbg]');
        let style = "background-image: url({url})";
        for (let i = 0; i < imgDefer.length; i++) {

            imgDefer[i].setAttribute('style', style.replace("{url}", imgDefer[i].getAttribute('data-srcbg')));

        }
    }

    window.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
    //window.dispatchEvent(new Event('resize'));
    // IE
    let evt = window.document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
});
